export default __webpack_public_path__ + "static/media/NotHoverNotice.38a47ebb.svg";